import classNames from "classnames";
import React from "react";
import { useTranslation } from "react-i18next";
import { Nav, NavItem, NavLink } from "reactstrap";

export const SideNav = React.memo(function SideNav(
    props: SideNavProps
): JSX.Element {
    const { t } = useTranslation();
    const {
        tabs,
        activeTab,
        activeSubTab,
        isSubMenuCollapsed,
        mainColor,
        chosenTemplateName,
        isCustomerAccountActive,
        isInformationModesEmpty,
        onTabClick,
        onSubTabClick,
    } = props;

    return (
        <Nav
            tabs
            role="tablist"
            className="d-flex flex-column"
            style={{ backgroundColor: mainColor }}
        >
            {tabs.map((element, index) => (
                <NavItem
                    key={element.id}
                    className={classNames("pb-1", element.customClassName)}
                >
                    <NavLink
                        data-testid={`modal-content-tab-${element.id}-btn`}
                        role="tab"
                        id={`tab-${element.id}`}
                        aria-selected={activeTab === index}
                        aria-controls={`panel-${element.id}`}
                        className={classNames(
                            "border-0 menu-wrapper-nav-link__clz",
                            {
                                "active menu-wrapper-items-nav-link-active__clz":
                                    activeTab === index,
                            },
                            {
                                "disable-account-creation-items__clz":
                                    chosenTemplateName === "",
                            }
                        )}
                        onClick={() =>
                            onTabClick(index, element.id === "configuration")
                        }
                    >
                        <span className="px-2">
                            {element.titleIcon}
                            {t(element.titleKey)}
                        </span>
                    </NavLink>
                    {element.id === "configuration" && isSubMenuCollapsed
                        ? element.subMenu?.map(
                              (
                                  item: SubMenuItem,
                                  subMenuIndex: number
                              ): JSX.Element => (
                                  <NavLink
                                      data-testid={`modal-content-subtab-${item.id}-btn`}
                                      role="tab"
                                      id={`tab-${element.id}-${item.id}`}
                                      aria-selected={
                                          activeSubTab === subMenuIndex
                                      }
                                      aria-controls={`panel-${element.id}-${item.id}`}
                                      disabled={
                                          (item.id === "loyaltyAccount" &&
                                              !isCustomerAccountActive) ||
                                          (item.id === "informationModes" &&
                                              isInformationModesEmpty)
                                      }
                                      key={item.id}
                                      className={classNames(
                                          "border-0 text-nowrap pl-5 menu-wrapper-nav-link__clz",
                                          {
                                              "active sub-menu-wrapper-items-nav-link-active__clz":
                                                  activeSubTab === subMenuIndex,
                                          },
                                          item.customClassName
                                      )}
                                      onClick={() =>
                                          onSubTabClick(subMenuIndex)
                                      }
                                  >
                                      <span>{t(item.titleKey)}</span>
                                  </NavLink>
                              )
                          )
                        : null}
                </NavItem>
            ))}
        </Nav>
    );
});
